






















































































































































































import { Component, Vue } from "vue-property-decorator";
import uploadNew from "@/components/uploadNew.vue";
import api from "@/api";
import { Message } from "element-ui";
import {imageUrl} from '@/utils/common'

@Component({
  components: {
    uploadNew: uploadNew
  }
})
export default class AUser extends Vue {
  baseUrl = imageUrl
  // 表格数据
  tableData = [
    {index: 1}
  ];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  config = {}

  model: any = {
    OSSAccessKeyId: "",
    signature: "",
    policy: "",
    key: "",
    callback: "",
    file: "",
    success_action_status: ''
  };


  // 日志
  logDialog = false;
  logDetail = false;
  logTable = [];
  logData = {};
  row = {};
  openDesc = false;
  logTotal = 0;
  logSearch = {
    objectId: "",
    objectType: "virtual_library",
    sort:{
      createTime:"desc"
    },
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  showLogDialog(item: any) {
    this.logSearch.objectId = item.id;
    this.logData = item;
    api.post("J27757", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changePage(page: any) {
    this.logSearch.pagination.page = page - 1
    api.post("J27610", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  handleCloseLogDialog() {
    this.logDialog = false;
  }
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }
  CloseLogDetailDialog() {
    this.logDetail = false;
  }


  actions() {
    return "J27136";
  }

    //上传
  fileList: any = [];
  formData = "";
  delFile() {
    this.fileList = [];
  }

    getBase64(file: any) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      let imgResult: any = "";
      reader.readAsDataURL(file);
      reader.onload = function() {
        imgResult = reader.result;
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.onloadend = function() {
        resolve(imgResult);
      };
    });
  }

  protected handleExceed(res: any) {
    Message.error({
      message: res,
      duration: 5 * 1000,
    });
  }
  baseInfo = ''
  handleChange(file: any, fileList: any) {
    var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
    const extension = testmsg === 'xlsx'
    if(!extension) {
      this.$message({
        message: '上传文件只能是xlsx格式!',
        type: 'warning'
      });
      this.fileList = [];
      return
    }
    this.getBase64(file.raw).then((res: any) => {
      this.baseInfo = res.split(',')[1]
    })
  }
  handleRemove(file: any, fileList: any) {
    console.log(file, fileList);
  }
  handlePreview(file: any) {

  }
  uploadFile(file: any) {
    (this.formData as any).append("file", file.file);
    this.submitUpload()
  }
  submitUpload() {
    let formData = new FormData();
    formData.append("file", (this.fileList[0] as any).raw);
  }

  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    api
        .post("J27710", this.search)
        .then((data) => {
          this.total = data.total;
          this.tableData = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
  }

  // 新增商品
  addDialog = false
  shopInfo: any = {}
  qudao = [{name: '掌纷享-直客', val: 'zhike'}, {name: '掌纷享-经纪人', val: 'broker'}]
  checked: any =[]
  add() {
    this.checked = []
    this.shopInfo = {}
    this.addDialog = true
  }

  getData1(item: any) {
    this.shopInfo.indexImg = item
  }
  getData2(item: any) {
    this.shopInfo.bannerImg = item
  }
  getData3(item: any) {
    this.shopInfo.detailsImg = item
  }
  sureAdd() {
    if(!this.shopInfo.virtualProductName) {
      this.$message.warning('商品名称不能为空');
      return
    }
    this.shopInfo.excelFile = this.baseInfo
    // this.shopInfo.id = ''
    this.loading = true
    api
      .post(this.shopInfo.id? 'J27708':'J27759', this.shopInfo)
      .then(res => {
        this.$message.success('操作成功')
        this.addDialog = false
        this.searchTable()
      }).finally(() => {
        this.loading = false
      })
  }

  handleCancle() {
    this.shopInfo = {}
    this.addDialog = false
  }


  // 编辑
  edit(row:any) {
    this.$router.push({
      path: '/integral/virtualGoodsEdit',
      query: {
        id: row.id
      }
    })  

  }

  // 操作
  setStatus(row: any, val: any){
    // 0 上架  1 下架 2 删除
    let tips: any = val == 0 ? "确定上架该虚拟商品?" : (val == 1 ? '确定下架该虚拟商品?' : ( val == 2 ? '确定删除该虚拟商品?' : null ) )
    let apiVal: any = val == 0 ? "J27711" : (val == 1 ? 'J27712' : ( val == 2 ? 'J27760' : null ) )
    this.$confirm( tips , "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      api
          .post(apiVal, {id: row.id})
          .then((res: any) => {
            this.$message.success("操作成功");
            this.searchTable()
          })

    });
  }

  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }

  activated() {
    this.getConfig()
    this.searchTable();
  }
}
